<div class="main-content">
  <div class="container-fluid">
    <router-outlet name="survey-form"></router-outlet>
  </div>
</div>
